import {
  SVGUploadFiles,
  SVGUploadImage,
  SVGUploadLogoImage,
} from "../../assets/register/svgs";
import type { User, WorkerProfile } from "../../../types/userTypes";
import { api } from "@/utils/api";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { logoutUser, updateUser } from "@/features/user/userSlice";
import { toast } from "@/utils/appToast";
import { useTranslation } from 'react-i18next';
import { Logout } from "@/shared/services/credentialsService";
import Resizer from "react-image-file-resizer";


type StepProps = {
  handleChangeStep?: (back?: boolean) => void;
  workerProfile?: WorkerProfile;
};

export function UpdateWorkerStep2({
  handleChangeStep,
  workerProfile,
}: StepProps) {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const [imgPreview, setImgPreview] = useState<string>("");
  const [user, setUser] = useState<User>({} as User);

  useEffect(() => {
    setImgPreview(workerProfile?.logoURL);
  }, []);
  const navigate = useNavigate();

  const handleImgPreview = (e) => {
    const file = e.target.files[0];

    if (file.size > 10 * 1024 * 1024) {
      toast.error("The profile photo cannot exceed 10MB");
      return;
    }


    if (file) {
      const reader = new FileReader();

      reader.onload = () => {
        setImgPreview(reader.result as string);
      };

      reader.readAsDataURL(file);
    }
  };

  const resizeImage = async (file: File) => {
    if (file.size > 10 * 1024 * 1024) {
      toast.error("The profile photo cannot exceed 10MB");
      return;
    }

    return new Promise<Blob>((resolve) => {
      Resizer.imageFileResizer(
        file,
        1500,
        1500,
        'JPEG',
        90,
        0,
        (uri: any) => {
          resolve(uri);
        },
        'blob'
      );
    });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    setIsLoading(true)
    e.preventDefault();
    const formData = new FormData(e.target as HTMLFormElement);
    const avatarImg = formData.get("avatar") as File;
    // 1. Handle avatar image upload
    if (avatarImg && avatarImg.size) {
      const resizedImage = await resizeImage(avatarImg);
      const avatarFormData = new FormData();
      avatarFormData.set("file", resizedImage);
      const userWithAvatarImg = await api.updateLogoPhoto(avatarFormData);
      dispatch(updateUser({ ...userWithAvatarImg }));
    }

    // 2. Collect all form data including subscription
    const newUserData = Object.fromEntries(formData);

    // 3. Update worker profile
    try {
      const res = await api.updateMyWorkerProfile(newUserData);
        toast.success("Profile updated successfully. Please verify your email to continue.");
      
      
    } catch (error) {
      console.error("Error in form submission:", error);
      toast.error(
        error.response?.data?.message ||
        "Error updating profile. Please try again."
      );
    } finally {
      localStorage.clear();
      sessionStorage.clear();
      setIsLoading(false)
      dispatch(logoutUser())
      Logout(false).then(() => {
        navigate("/");
      })
    }
  };

  return (
    <main style={{ maxWidth: "1013px", margin: "auto" }}>
      <form action="" className="m-auto" onSubmit={handleSubmit}>
        <div
          style={{
            padding: "20px",
          }}
        >
          <label className="fw-bold" htmlFor="registerWorkerLogoImg">
            {t('uploadLogoIfAny')}
          </label>

          <div className="col-4 d-flex sm:justify-content-center justify-content-start">
            <label htmlFor="registerWorkerImg" style={{ cursor: "pointer" }}>
              {imgPreview ? (

                <img
                  src={imgPreview}
                  alt=""
                  className="sm:w-36 sm:h-36 w-24 h-24 rounded-full object-cover"
                />
              ) : (
                <SVGUploadLogoImage className=" sm:w-42 sm:h-42 w-44 h-44" />
              )}


            </label>
            <input
              id="registerWorkerImg"
              type="file"
              accept="image/*"
              onChange={handleImgPreview}
              name="avatar"
              className="d-none"
            />
          </div>

          <div className="mb-4">
            <label className="fw-bold" htmlFor="registerWorkerAbout">
              {t('tellUsAboutService')}
            </label>
            <textarea
              id="registerWorkerAbout"
              className="form-control my-2"
              name="description"
              rows={6}
              placeholder={t('exampleExperience')}
              defaultValue={workerProfile?.description}
            />
          </div>
        </div>

        <div className="d-flex sm:px-0 px-6">
          <button
            className="d-block btn btn-primary my-3 w-25 me-auto"
            style={{ background: "#4285f4", outline: "none", border: "none" }}
            type="button"
            onClick={() => handleChangeStep(true)}
          >
            {t('back')}
          </button>
          <button
            className="d-block btn btn-primary my-3 w-25 ms-auto"
            style={{
              background: "var(--primary-color)",
              outline: "none",
              border: "none",
            }}
            disabled={isLoading}
          >
            {isLoading ? (
              <div
                className="spinner-border"
                style={{ height: "15px", width: "15px" }}
                role="status"
              ></div>
            ) : (
              t('finish')
            )}
          </button>
        </div>
      </form>
    </main>
  );
}
